import React from 'react';
import { DispatchEvent, SessionContextType, SessionStateType } from './SmartTypes';

const SessionContext = React.createContext({
    sessionState: {} as SessionStateType,
    sessionDispatch: (dispatchEvent: DispatchEvent) => {},
} as SessionContextType);

export default SessionContext;
